export default "__VITE_ASSET__BSBiqW$Z__"